export enum NodeSortAction {
    Asc = "Asc",
    FolderFirstAsc = "FolderFirstAsc"
}